module.exports = "/assets/d0bbaf1c64bc3d7556b380c4f7e56c8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SK.png
// module id = 2945
// module chunks = 0